import React, { useEffect } from "react";
import HolderContainer from "../../components/Reusable/HolderContainer";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogList } from "../../actions/blog";
import { Link, useParams } from "react-router-dom";

import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { t } from "i18next"; // Import t function for translation

const BlogDetail = () => {
  const dispatch = useDispatch();
  const { blogDetail } = useSelector((state) => state.blogReducer);
  const { id } = useParams();

  useEffect(() => {
    dispatch(fetchBlogList(id));
  }, [dispatch, id]);

  return (
    <div className="blog-main-container">
      <Breadcrumb title={t("blogDetail.title")} returnPage="/blog" />

      <img src={blogDetail?.image} className="img-fluid mt-3" alt="LG" />
      <h1 className="blog-detail-title">{blogDetail?.name}</h1>
      <div
        className="blog-detail-description"
        dangerouslySetInnerHTML={{ __html: blogDetail?.description }}
      ></div>
    </div>
  );
};

export default BlogDetail;
